import { memo } from "react";
import Button from "@mui/material/Button";
import GetAppIcon from '@mui/icons-material/GetApp';
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import { Toolbar } from "ui/molecules/TableGrids";
import { useTypedSelector } from "hooks";
import type { TableToolbarProps } from "../types";

const TableToolbar = ({
    onExport,
    selectIsExportLoading,
    dataTestIdPrefix = 'table',
    ...restComponents
}: TableToolbarProps) => {
    const isExportLoading = useTypedSelector(selectIsExportLoading);

    return (
        <Box>
            {isExportLoading && <LinearProgress />}
            <Toolbar
                export={() => (
                    <Button
                        size='small'
                        startIcon={<GetAppIcon />}
                        onClick={onExport}
                        disabled={isExportLoading}
                        data-test-id={`${dataTestIdPrefix}.controls.export`}
                    >
                        Export
                    </Button>
                )}
                {...restComponents}
            />
        </Box>
    );
};

export default memo(TableToolbar);
